import { DocumentTypeEnum } from './document-type-enum';
import { Serializable } from '../../../core/models/serializable';

export class JobseekerFile implements Serializable<JobseekerFile> {
  fromObject(obj: any): JobseekerFile {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public jobseekerDocumentId: number;
  public jobseekerId: number;
  public type: number;
  public label: string;
  public contentType: string;
  public fileName: string;
  public createDate: Date;
}
